module.exports = __webpack_public_path__ + "img/arrow-right-orange.fe440dd5.svg";